import React, { useState } from 'react'
import { Divider, Empty, Popconfirm, Table, Tooltip, message, Badge } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faToggleOff, faToggleOn, faTrash } from '@fortawesome/free-solid-svg-icons'

import EditVehicleTypeModal from './EditVehicleTypeModal'

import { deleteVehicleType, updateVehicleType } from '../services'
import { handleError } from '../../../helpers'
import moment from 'moment'

export default function VehicleTypesTable({ vehicleTypes, reload }) {
	const [editModal, setEditModal] = useState(null)

	const columns = [
		{
			title: 'Código',
			dataIndex: 'sku'
		},
		{
			title: 'Tipo de Vehículo',
			dataIndex: 'name'
		},
		{
			title: 'Capacidad de Carga',
			dataIndex: 'load_capacity',
			render: t => `${t} toneladas`
		},
		{
			title: 'Tiempo de Descarga',
			dataIndex: 'unload_time'
		},
		{
			title: 'Estado',
			dataIndex: 'status',
			render: (t, r) => (
				<Badge color={r.status.color}>{r.status.label}</Badge>
			)
		},
		{
			title: 'Acciones',
			width: '100px',
			render: (t, r) => (
				<React.Fragment>
					<Tooltip title={r.disabled_at ? 'Habilitar' : 'Deshabilitar'} className='text-link'>
						<FontAwesomeIcon 
							icon={r.disabled_at ? faToggleOff : faToggleOn} 
							onClick={() => handleToggle(r)} 
						/>
					</Tooltip>
					<Divider type="vertical" />
					<Tooltip title="Editar" className='text-link'>
						<FontAwesomeIcon icon={faEdit} onClick={() => setEditModal(r)} />
					</Tooltip>
					{ r.appointments_count === 0 && (
						<React.Fragment>
							<Divider type="vertical" />
							<Popconfirm
								title="Esta acción no se puede revertir"
								okText="Eliminar"
								cancelText="Cancelar"
								okButtonProps={{ danger:true }}
								onConfirm={() => handleDelete(r.id)}
							>
								<Tooltip 
									title="Eliminar" 
									className='text-link'
									placement='bottom'
								>
									<FontAwesomeIcon icon={faTrash} />
								</Tooltip>
							</Popconfirm>
						</React.Fragment>
					)}
				</React.Fragment>
			)
		}
	]

	const handleDelete = id => {
		deleteVehicleType(id)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	const handleToggle = record => {
		updateVehicleType(record.id, { 
			disabled_at: record.disabled_at ? null : moment().format('YYYY-MM-DD HH:mm:ss') 
		})
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(error => handleError(error))
	}

	const expandedRowRender = (record) => {
		return (
			<React.Fragment>
				<p>Fecha de creación: {record.created_at}</p>
				<p>Fecha última actualización: {record.updated_at}</p>
			</React.Fragment>
		)
	}

	return (
		<React.Fragment>
			<Table 
				dataSource={vehicleTypes}
				columns={columns}
				rowKey={r => r.id}
				loading={!vehicleTypes}
				size='small'
				expandable={{ expandedRowRender }}
				locale={{ 
					emptyText: (
						<Empty 
							description="No se encontraron registros" 
							imageStyle={{ height:'80px' }}
						/>
					) 
				}}
			/>
			{ editModal && (
				<EditVehicleTypeModal 
					visible
					onClose={() => setEditModal(null)}
					reload={reload}
					vehicleType={editModal}
				/>
			)}
		</React.Fragment>
	)
}